module.exports = __webpack_public_path__ + "img/icon3@2x.09b59a87.png";